import * as API from '../_api';

const randomId = () => `_${Math.random().toString(36).substr(2, 9)}`;

export const create = async ({ dispatch }, { event, image }) => {
  try {
    if (image) {
      const imageName = `${randomId()}.${image.name.split('.').pop()}`;
      await API.uploadEventTitleImage(imageName, image);
      event.imageUrl = `https://images.einkaufskreis.at/event/${imageName}`;
    } else {
      throw new Error('Image is missing');
    }
    await API.create(event);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const read = async ({ commit, dispatch }) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const update = async ({ dispatch }, { event, image, files }) => {
  try {
    if (files) {
      // upload gallery files here and save urls to event. maybe filter the shizz? like images only and shit?
      const promises = [];
      const gallery = [];
      for (let i = 0; i < files.length; i += 1) {
        const fileName = `${randomId()}.${files[i].name.split('.').pop()}`;
        gallery.push(`https://images.einkaufskreis.at/event/${event.id}/${fileName}`);
        promises.push(API.uploadEventGalleryImage(fileName, event, files[i]));
      }

      await Promise.all(promises);
      // join arrays here?
      if (!event.galleryImages) {
        event.galleryImages = gallery;
      } else {
        console.log(event.galleryImages);
        event.galleryImages = event.galleryImages.concat(gallery);
      }
    }

    if (image) {
      const imageName = `${randomId()}.${image.name.split('.').pop()}`;
      await API.uploadEventTitleImage(imageName, image);
      event.imageUrl = `https://images.einkaufskreis.at/event/${imageName}`;
    }

    await API.update(event);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const del = async ({ dispatch }, event) => {
  try {
    await API.del(event);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};
